




























import Vue from 'vue';
import { Datepicker, DatepickerValidationMode } from '@ringana/datepicker';
import { startOfToday } from 'date-fns';
import ErrorHandlerHelper from '../../../helpers/ErrorHandlerHelper';
import config from '../../../../config';

interface IFilterTextInputComponent {
  DatepickerValidationMode: typeof DatepickerValidationMode;
  months: number[] | string[];
}

export default Vue.extend({
  name: `FilterTextInput`,
  components: { Datepicker },
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): IFilterTextInputComponent {
    return {
      DatepickerValidationMode,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  props: {
    datepickerClearable: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: ``,
      type: String,
    },
    maxDate: {
      default: startOfToday().getTime(),
      type: [String, Number],
    },
    minDate: {
      default: new Date(2000, 0, 1).getTime(),
      type: [String, Number],
    },
    placeholder: {
      default: ``,
      type: String,
    },
    showDatePicker: {
      default: false,
      type: Boolean,
    },
    type: {
      default: ``,
      type: String,
    },
    value: {
      default: null,
      type: [Date, String],
    },
  },
  mounted(): void {
    this.initMonthStrings();
  },
  methods: {
    handleDatepickerError($event: { errorText: string }): void {
      ErrorHandlerHelper.handleError($event.errorText, {
        logToConsole: true,
      });
    },
    initMonthStrings(): void {
      if(!this.showDatePicker) {
        return;
      }
      this.months = config.datepicker.months.map(key => this.$t(key).toUpperCase());
    },
  },
});
